import React, {useRef} from 'react';
import './style.css'
import {Link} from "react-router-dom";
import Button from "../Common/Button";
import IMG from "../../constants/image";
import {QRCodeCanvas} from 'qrcode.react';
import merchantStore from "../../store/merchantStore";
import {ENV} from "../../network/config";
import {toast} from "react-toastify";
import popupStore from "../../store/popupStore";
import cn from "classnames";

const Share = () => {
    const pathname = location.pathname;
    const {merchantProfile} = merchantStore();
    const {isOpen} = popupStore() || {};


    const {handle} = merchantProfile || {};
    const qrCodeRef = useRef();

    const merchantUrl = `${ENV.FUNONG_DOMAIN}/shop/${handle}`;

    const handleCopy = () => {
        navigator.clipboard.writeText(merchantUrl)
            .then(() => {
                toast('Sao chép đường dẫn thành công');
            })
    };

    const handleDownload = () => {
        if (qrCodeRef.current) {
            const canvas = qrCodeRef.current;
            const pngUrl = canvas.toDataURL("image/png"); // Convert canvas to data URL

            if (window?.ReactNativeWebView) {
                // Post the base64 image to the React Native app
                window.ReactNativeWebView?.postMessage(JSON.stringify({
                    type: "IMAGE_BASE64",
                    data: pngUrl
                }));
            } else {
                const downloadLink = document.createElement('a');
                downloadLink.href = pngUrl;
                downloadLink.download = 'qrcode.png'; // Set download file name
                downloadLink.click();
            }
        }
    }

    return (
        <div className='flex flex-col gap-[15px] justify-center items-center md:mt-[15px]'>
            <div className={cn(isOpen ? 'share-popup' : 'share-section')}>
                <p>Đường dẫn liên kết gian hàng</p>
                <Link
                    className='text-center text-[#197D55] cursor-pointer underline w-full text-ellipsis-end'
                    to={merchantUrl} target='_blank'>
                    {merchantUrl}
                </Link>
                <Button className='text-xs h-[34px] bg-[#FAFAFC]' onClick={handleCopy}>
                    Sao chép
                    <img className='ml-1' src={IMG.icon.copy} alt="copy"/>
                </Button>
            </div>
            <div className={cn(isOpen ? 'share-popup' : 'share-section')}>
                <p>Hoặc quét mã để truy cập gian hàng</p>
                <QRCodeCanvas
                    ref={qrCodeRef}
                    className='p-1 border-4 border-[#EDEDED]'
                    value={merchantUrl} size={152} level={"H"}
                />
                <Button className='text-xs h-[34px] bg-[#FAFAFC]' onClick={handleDownload}>
                    <img className='mr-1' src={IMG.icon.download} alt="download"/>
                    Tải ảnh
                </Button>

            </div>
        </div>
    )
}

export default Share;
